export default __webpack_public_path__ + "static/winter9-7ced0b201c72109cadfb8f999b285f67.webp";